import * as actionTypes from "./actionTypes";

const initialState = {
  error: false,
  errorMessage: "",
  message: "",
  loading: false,
};

const Contact = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CONTACT_LOADING:
      return {
        ...initialState,
        loading: true,
      };

    case actionTypes.RESET_MESSAGE:
      return {
        ...initialState,
      };

    case actionTypes.SEND_CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.message,
      };
    case actionTypes.SEND_CONTACT_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.errorMessage,
      };

    default:
      return { ...state };
  }
};

export default Contact;
